import { useTranslation } from "react-i18next";
import { formatDate, formatDateTime, formatEndTime } from "../lib/date";

export interface LocaleFormatters {
  /** A date for a person, in the active language. */
  formatDate: (iso: string | null) => string;
  /** A date and time for a person, in the active language. */
  formatDateTime: (iso: string | null) => string;
  /** A UTC deadline for display, in the active language. */
  formatEndTime: (end: Date) => string;
}

/** The date formatters from lib/date, bound to the active UI language. Re-renders on language change. */
export function useLocaleFormatters(): LocaleFormatters {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  return {
    formatDate: (iso) => formatDate(iso, locale),
    formatDateTime: (iso) => formatDateTime(iso, locale),
    formatEndTime: (end) => formatEndTime(end, locale),
  };
}
